var ScrollHandler = (() => {
    var _this, CONFIG, ELEMENT, STATUS, TIMER;

    CONFIG = {
        TARGET_FACTOR: 0.25,
        MAX_TARGET: 300,
        OPTIONS: {}
    };

    ELEMENT = {
        html: document.querySelector('html'),
        body: document.querySelector('body'),
        container: null,
        indicator: null
    };

    TIMER = {};

    function resetStatus() {
        clearTimeout(TIMER.resetStatus);

        STATUS = {
            touching: false,
            activating: false,
            start: 0,
            target: 0,
            progress: 0
        };

        updateTouchAction();

        if (ELEMENT.indicator) {
            ELEMENT.indicator.style.height = `${Math.round(CONFIG.TARGET_FACTOR * 100)}vh`;
            ELEMENT.indicator.style.maxHeight = `${CONFIG.MAX_TARGET}px`;
            ELEMENT.indicator.style.transition = 'transform 0.25s';
            ELEMENT.indicator.style.setProperty('--progress', 0);
            ELEMENT.indicator.classList.remove('fullProgress');
        }
    }
    resetStatus();

    function isActive() {
            return STATUS.touching && STATUS.activating;
    }

    function hasScrolled() {
        return ((ELEMENT.container ? ELEMENT.container.scrollTop : Math.max(ELEMENT.html.scrollTop, ELEMENT.body.scrollTop)) > 0);
    }

    function isInsideScrollableElement(element) {
        var scrollRoot, overflowY;

        scrollRoot = ELEMENT.container || ELEMENT.body;

        while (element && (element !== scrollRoot) && (element !== ELEMENT.html)) {
            if (element.nodeType === Node.ELEMENT_NODE && (element.scrollHeight > element.clientHeight)) {
                overflowY = window.getComputedStyle(element).overflowY;

                if ((overflowY === 'auto') || (overflowY === 'scroll')) {
                    return true;
                }
            }

            element = element.parentNode;
        }

        return false;
    }

    function updateTouchAction() {
        var scrollElement, action;

        action = (ELEMENT.indicator && !hasScrolled()) ? 'pan-down' : '';

        scrollElement = ELEMENT.container || ELEMENT.body;
        scrollElement.style.touchAction = action;
    }

    function preventWindowScroll(event) {
        if (!isActive()) {
            return;
        }

        event.preventDefault();
    }

    function startTouch(event) {
        resetStatus();

        if (!ELEMENT.indicator || event.target.closest('.noOverScroll') || (ELEMENT.container && (event.touches[0].clientY < $(ELEMENT.container).offset().top))) {
            return;
        }

        if (hasScrolled() || isInsideScrollableElement(event.target)) {
            return;
        }

        ELEMENT.indicator.style.transition = '';

        STATUS.touching = true;
        STATUS.start = event.touches[0].clientY;
        STATUS.target = Math.min((CONFIG.TARGET_FACTOR * window.innerHeight), CONFIG.MAX_TARGET);
    }

    function moveTouch(event) {
        if (!STATUS.touching) {
            return;
        }

        STATUS.progress = Math.min(1, (event.touches[0].clientY - STATUS.start) / STATUS.target);
        STATUS.activating = STATUS.activating || (STATUS.progress > 0);

        if (!STATUS.activating) {
            resetStatus();
            return;
        }

        event.preventDefault();
        event.stopPropagation();

        if (ELEMENT.indicator) {
            ELEMENT.indicator.style.setProperty('--progress', Math.max(0, STATUS.progress));
        }
    }

    function endTouch(event) {
        let isTriggered;

        isTriggered = STATUS.touching && (STATUS.progress === 1);

        if (ELEMENT.indicator) {
            ELEMENT.indicator.classList.toggle('fullProgress', isTriggered);
        }

        if (isTriggered) {
            if (CONFIG.OPTIONS.beforePulledToRefresh) {
                CONFIG.OPTIONS.beforePulledToRefresh();
            }

            setTimeout(() => {
                $(document).trigger('pulledToRefresh');

                if (CONFIG.OPTIONS.afterPulledToRefresh) {
                    CONFIG.OPTIONS.afterPulledToRefresh();
                }
            }, CONFIG.OPTIONS.delay || 700);
        }

        clearTimeout(TIMER.resetStatus);

        TIMER.resetStatus = setTimeout(() => {
            resetStatus();
        }, isTriggered ? 2000 : 0);
    }

    document.addEventListener('touchstart', startTouch, {capture: true, passive: false});

    document.addEventListener('touchmove', moveTouch, {capture: true, passive: false});

    window.addEventListener('scroll', preventWindowScroll, {capture: true, passive: false});

    window.addEventListener('scroll', updateTouchAction, {passive: true});

    window.addEventListener('wheel', preventWindowScroll, {capture: true, passive: false});

    document.addEventListener('touchend', endTouch, {capture: true, passive: false});

    document.addEventListener('touchcancel', endTouch, {capture: true, passive: false});

    _this = {
        activate: function(indicatorSelector, containerSelector, options) {
            ELEMENT.indicator = document.querySelector(indicatorSelector);
            ELEMENT.container = containerSelector ? document.querySelector(containerSelector) : null;
            CONFIG.OPTIONS = options || {};
            updateTouchAction();
        },
        deactivate: function() {
            resetStatus();
            ELEMENT.indicator = null;
            updateTouchAction();
        },
        stop: function() {
            resetStatus();
        }
    };

    return _this;
})();